<div class="wrapp-subscribe">
    <div class="modal fade show" id="revmodal" tabindex="-1" aria-labelledby="revModalLabel" aria-hidden="true"
        style="display: block;">
        <div class="modal-dialog ">
            <div class="modal-content p-4 bg-popup-color">
                <div class="sweet-alert showSweetAlert">
                    <div class="sa-icon sa-error d-none">
                        <span class="sa-x-mark">
                            <span class="sa-line sa-left"></span>
                            <span class="sa-line sa-right"></span>
                        </span>
                    </div>
                    <div class="sa-icon sa-warning d-none">
                        <span class="sa-body"></span>
                        <span class="sa-dot"></span>
                    </div>
                    <div class="sa-icon sa-info d-none"></div>
                    <div class="sa-icon sa-success animate d-block">
                        <span class="sa-line sa-tip animateSuccessTip"></span>
                        <span class="sa-line sa-long animateSuccessLong"></span>
                        <div class="sa-placeholder"></div>
                        <div class="sa-fix"></div>
                    </div>
                    <div class="sa-icon sa-custom d-none"></div>
                    <h2>Congrats!</h2>
                    <p class="d-block">{{data.message}}</p>
                    <div class="sa-error-container">
                        <div class="icon">!</div>
                        <p>Not valid!</p>
                    </div>
                    <div class="sa-button-container">
                        <button class="cancel d-none" tabindex="2" (click)="closePopup()">Cancel</button>
                        <button class="confirm d-inline-block" tabindex="1" (click)="closePopup()">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>